import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserWeb3, useTryConnect, isMobile } from '@moverfinance/web3';
import styles from './wallet.module.css';
import { ExternalLink, ModalV2, Radio } from 'components';
import { track, trackName } from 'vendor/mixpanel';
import { injected, walletconnect as walletConnect } from 'connectors/injected';
import { runCallback } from 'utils';
import { ReactComponent as MetaMask } from 'assets/icons/metamask.svg';
import { ReactComponent as WalletConnect } from 'assets/icons/walletconnect.svg';

export interface WalletProps {
  hiddenMenu?: () => void;
  showNetSelect?: boolean;
}

const Wallet: React.FC<WalletProps> = ({
  hiddenMenu,
  showNetSelect = false
}) => {
  const { t } = useTranslation();
  const { error } = useUserWeb3();
  const [callback, setCallback] = useState(false);
  const [showWallet, setShowWallet] = useState(false);
  const [agree, setAgree] = useState(false);
  const tryConnect = useTryConnect();

  const connectMetaMask = useCallback(() => {
    track(trackName.CONNECT_WALLET);
    tryConnect(injected);
    localStorage.setItem('provider', 'injected');
    setShowWallet(false);
  }, [tryConnect]);

  const connectWalletConnect = useCallback(() => {
    track(trackName.CONNECT_WALLET);
    tryConnect(walletConnect);
    localStorage.setItem('provider', 'walletConnect');
    setShowWallet(false);
  }, [tryConnect]);

  const connectWallet = useCallback(() => {
    if (isMobile) {
      connectMetaMask();
    } else {
      setShowWallet(true);
    }
  }, [connectMetaMask]);

  useEffect(() => {
    if (callback || !isMobile) return;
    if (error) {
      hiddenMenu && runCallback(hiddenMenu, false);
      setCallback(true);
    }
  }, [error, hiddenMenu, callback]);

  return (
    <>
      {window.ethereum ? (
        <button className={styles.wallet} onClick={connectWallet}>
          {t('common.connectWallet')}
        </button>
      ) : (
        <ExternalLink
          className={styles.wallet}
          to={
            isMobile
              ? `https://metamask.app.link/dapp/${window.location.host}`
              : 'https://metamask.io/download.html'
          }
        >
          {t('common.connectWallet')}
        </ExternalLink>
      )}
      <ModalV2
        visible={showWallet}
        title={'Connect to wallet'}
        onClose={setShowWallet}
        className={styles.modal}
      >
        <div className={styles.modalInfo}>
          <Radio
            name="agree"
            value={'true'}
            checked={agree}
            onChange={() => setAgree(true)}
            className={styles.modalInfoRadio}
          ></Radio>
          <div className={styles.modalInfoDesc}>
            I read and accept RunBlox’{' '}
            <ExternalLink
              to="https://runblox.io/terms.html"
              className={styles.modalInfoLink}
            >
              Terms of Service
            </ExternalLink>{' '}
            and{' '}
            <ExternalLink
              to="https://www.iubenda.com/privacy-policy/30870666"
              className={styles.modalInfoLink}
            >
              Privacy Policy
            </ExternalLink>
            .
          </div>
        </div>
        <div className={styles.modalInner}>
          <button
            type="button"
            disabled={!agree}
            className={styles.modalButton}
            onClick={connectMetaMask}
          >
            <MetaMask className={styles.modalIcon} />
            METAMASK
          </button>
          <button
            type="button"
            disabled={!agree}
            className={styles.modalButton}
            onClick={connectWalletConnect}
          >
            <WalletConnect className={styles.modalIcon} />
            WALLETCONNECT
          </button>
        </div>
      </ModalV2>
    </>
  );
};
export default Wallet;
